import { render, staticRenderFns } from "./Jointable.vue?vue&type=template&id=671876c2&scoped=true"
import script from "./Jointable.vue?vue&type=script&lang=js"
export * from "./Jointable.vue?vue&type=script&lang=js"
import style0 from "./Jointable.vue?vue&type=style&index=0&id=671876c2&prod&scoped=true&lang=css"
import style1 from "./Jointable.vue?vue&type=style&index=1&id=671876c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671876c2",
  null
  
)

export default component.exports